export class NewsFilter {
    constructor(selector) {

        this.elementContainerElements = document.querySelectorAll(selector);

        if (!this.elementContainerElements) {
            return false;
        }


        this.elementContainerElements.forEach(element => {

            let inputsValue = element.querySelectorAll('.js-hidden-valuer-trigger');
            if (!inputsValue) {
                return false;
            }


            console.log(inputsValue);

            var prev = null;
            inputsValue.forEach(rad => {
                rad.addEventListener('change', function () {
                    (prev) ? '' : null;
                    if (this !== prev) {
                        prev = this;
                    }


                    window.location.href = this.value;
                });
            });

            // inputsValue.onchange = this.changeDetector.bind(this);

        });

    }

    changeDetector(event) {
        event.preventDefault();
        console.log(event.target.value);
    }

}